<template>
    <div class="saveNameScreen">
        <b-modal
            v-bind:no-close-on-esc="true"
            v-bind:no-close-on-backdrop="true"
            v-bind:hide-header-close="true"
            v-bind:ok-only="true"
            v-bind:visible="true"
            ok-title="Save"
            @ok="saveName"
            @show="modalOpened"
            centered
            title="Enter your name"
        >
            <form v-on:submit.prevent="saveName">
                <b-input placeholder="Your name" spellcheck="false" autocomplete="off" v-model="name" :state="validate" id="playerNameInput"></b-input>
            </form>
        </b-modal>
    </div>
</template>
<script>
import store from "@/store";
import Helpers from "@/helpers";
const uuidv1 = require("uuid/v1");
export default {
    data: () => {
        return {
            name: ""
        };
    },
    methods: {
        saveName: function(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!this.name.trim().length) return;
            store.dispatch("setPlayerName", this.name.trim());
            let player = {
                id: uuidv1(),
                name: this.name.trim()
            };
            Helpers.localStorage.set("player", player);
            store.dispatch("setPlayer");
            store.state.howToPlayModal = true;
        },
        modalOpened: function() {
            setTimeout(() => {
                document.getElementById("playerNameInput").select();
            }, 100);
        }
    },
    computed: {
        validate() {
            return this.name.trim().length > 0;
        }
    }
};
</script>